export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('from_label_sample_style_no') || '样品款号',
    field: 'sampleStyleNo',
    width: 160,
    align: 'left',
    fixed: 'left',
    showHeaderOverflow: true,
    slots: { default: 'sampleStyleNo' },
  },
  {
    title: that.$l('from_label_sample_name') || '样品中文名称',
    field: 'sampleName',
    minWidth: 300,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  // {
  //   title: that.$l('table_label_productLine') || '产品线',
  //   field: 'v_productLine',
  //   minWidth: 120,
  //   align: 'left',
  //   headerAlign: 'left',
  //   showHeaderOverflow: true
  // },
  {
    title: that.$l('INDEX.form_label_business_name') || '业务员',
    field: 'salesPersonName',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyPersonName') || '工厂业务员',
    field: 'ftyPersonName',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_Level_2_sample_classification') || '样品分类',
    field: 'v_categoryCode',
    minWidth: 120,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleSource') || '样品来源',
    field: 'v_sampleSource',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sample_composition') || '样品成分',
    field: 'sampleComposition',
    minWidth: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleSpec') || '产品规格',
    field: 'specInfo',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'specInfo' },
  },
  {
    title: that.$l('table_label_sampleWeight') || '产品重量',
    field: 'sampleWeight',
    minWidth: 100,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'weightInfo' },
  },
  {
    title: that.$l('table_label_factory') || '成品工厂',
    field: 'scmName',
    minWidth: 160,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factory_product_number') || '工厂产品编号',
    field: 'scmProductNo',
    minWidth: 160,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_costMainType') || '主成本类型',
    field: 'v_costMainType',
    minWidth: 160,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_costPrice') || '成本价格',
    field: 'costPrice',
    minWidth: 160,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'costPriceInfo' },
  },
  {
    title: that.$l('table_label_custName') || '客户',
    field: 'custName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_brandName') || '品牌',
    field: 'brandName',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_customerProductNo') || '客人产品编号',
    field: 'customerProductNo',
    minWidth: 160,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custSampleName') || '客户样品名称',
    field: 'custSampleName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleSalesSeason') || '销售季节',
    field: 'v_sampleSalesSeason',
    minWidth: 120,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quotation_method') || '报价方式',
    field: 'v_quotedMethod',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quotedPrice') || '建议报价',
    field: 'quotedPrice',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'quotedPriceInfo' },
  },
  {
    title: that.$l('table_label_salesPrice') || '零售价',
    field: 'salesPrice',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySalesPrice' },
  },
  {
    title: that.$l('table_label_moq') || '起订量',
    field: 'moq',
    minWidth: 120,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'moqInfo' },
  },
  {
    title: that.$l('table_label_packageSize') || '包装尺寸',
    field: 'packageSize',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_packageMethod') || '包装方式',
    field: 'packageMethodName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_dateOfSignature') || '签样日期',
    field: 'dateOfSignature',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_poNo') || 'PO单号',
    field: 'poNo',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    field: 'modifyByName',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
  {
    field: 'v_inputSource',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    title: that.$l('table_label_inputSource') || '样品输入来源',
    showHeaderOverflow: true,
  },
]
